var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.3"},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.29289 1.79289C5.68342 1.40237 6.31658 1.40237 6.70711 1.79289L13.4142 8.5L6.70711 15.2071C6.31658 15.5976 5.68342 15.5976 5.29289 15.2071C4.90237 14.8166 4.90237 14.1834 5.29289 13.7929L10.5858 8.5L5.29289 3.20711C4.90237 2.81658 4.90237 2.18342 5.29289 1.79289Z","fill":"#E8EFFF"})));
}

ArrowRight.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
